import { Injectable } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { BootstrapConfig } from './bootstrap-config.model';

@Injectable({
  providedIn: 'root'
})
export class BootstrapService {
  private bootstrapConfigsValue: BootstrapConfig[] = [];

  constructor() {}

  get bootstrapConfigs(): BootstrapConfig[] {
    return this.bootstrapConfigsValue;
  }

  public add(bootstrapConfig: BootstrapConfig): void {
    this.bootstrapConfigsValue.push(bootstrapConfig);
  }

  public start(): void {
    this.bootstrapConfigsValue.forEach((item: BootstrapConfig) => this.doBootstrap(item));
  }

  private doBootstrap(bootstrapConfig: BootstrapConfig): void {
    if (!customElements.get(bootstrapConfig.tag)) {
      const element = createCustomElement(bootstrapConfig.component, { injector: bootstrapConfig.injector });
      customElements.define(bootstrapConfig.tag, element);
    }
  }
}
